export default "__VITE_ASSET__DegsPKSf__"